module.exports = __webpack_public_path__ + "img/0Q3B5795_BlackMatted_MockedUp.9fa5b89f.jpg";